import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getCompliance, getEngineStatus } from "../services/api";
import { maintenanceAttention } from "./maintenance-attention";
import { useSelectedVessel } from "./useSelectedVessel";

export default function MaintenanceBadge() {
  const { t } = useTranslation();
  const options = { staleTime: 60_000, refetchInterval: 60_000 };
  const engines = useQuery({ queryKey: ["logbook", "engines"], queryFn: getEngineStatus, ...options });
  const deadlines = useQuery({ queryKey: ["logbook", "compliance"], queryFn: getCompliance, ...options });
  const { vessel, query: vessels } = useSelectedVessel();
  const count = vessel ? maintenanceAttention(engines.data?.data ?? [], deadlines.data?.data ?? [], [vessel]) : 0;
  const failed = engines.isError || deadlines.isError || vessels.isError;
  if (!count && !failed) return null;
  const label = failed ? t("maintenance.countUnavailable") : t("maintenance.attention", { count });
  return <span title={label} aria-label={label} className="ml-2 inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white">{failed ? "!" : count > 99 ? "99+" : count}</span>;
}
